<template>
  <!-- start navigation -->
  <div class="navbar navbar-fixed-top navbar-default" role="navigation">
    <div class="container" style="height: 80px;">
      <div class="navbar-header" style="height: 100px;" >
        <button class="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
          <span class="icon icon-bar primary-bk"></span>
          <span class="icon icon-bar primary-bk"></span>
          <span class="icon icon-bar primary-bk"></span>
        </button>
        <img src="../../../static/img/landing/shutterstock_464244548.jpg" style="height: 100px; float: left;" />
        <a href="#" class="navbar-brand"><img src="../../../static/img/logo-small.png" alt="Kirnil Technologies Logo" /></a>
      </div>
      <div class="collapse navbar-collapse" style="background-color: #367fa9;">
        <ul class="nav navbar-nav navbar-right">
          <li><a v-scroll-to="'#info'" @click="$parent.activeMenu='HOME'" :class="['smoothScroll', $parent.activeMenu=='HOME' ? 'active' : '']">HOME</a></li>
          <li><a v-scroll-to="'#Dashboard'" href="#Dashboard" @click="$parent.activeMenu='Dashboard'" :class="['smoothScroll', $parent.activeMenu=='Dashboard' ? 'active' : '']">DASHBOARD</a></li>
          <li><a v-scroll-to="'#service'" @click="$parent.activeMenu='SERVICE'" :class="['smoothScroll', $parent.activeMenu=='SERVICE' ? 'active' : '']">SERVICES</a></li>
          <li><a v-scroll-to="'#portfolio'" @click="$parent.activeMenu='PROJECTS'" :class="['smoothScroll', $parent.activeMenu=='PROJECTS' ? 'active' : '']">PARTNERS</a></li>
          <li v-if="0>1"><a @click="$root.goto('Download')" :class="['smoothScroll', $parent.activeMenu=='DOWNLOADS' ? 'active' : '']">DOWNLOADS</a></li>
          <li><a v-scroll-to="'#contact'" @click="$parent.activeMenu='CONTACT'" :class="['smoothScroll', $parent.activeMenu=='CONTACT' ? 'active' : '']">CONTACT</a></li>
          <li><a @click="$root.goto('Guide')" :class="['smoothScroll', $parent.activeMenu=='DOCUMENTATION' ? 'active' : '']">DOCUMENTATION</a></li>
          <li><a @click="$root.goto('Login')" :class="['smoothScroll']">LOGIN</a></li>
        </ul>
      </div>
    </div>
  </div>
  <!-- end navigation -->
</template>
<script>
  export default {
    name: 'navbar',
    data () {
      return {
        showPrice: false
      }
    },
    computed: {
    },
    methods: {
      GotoContact () {
        this.$parent.activeMenu = 'CONTACT'
        // v-scroll-to="'#contact'"
        console.log('this.$scrollTo(#contact)')
        // this.$scrollTo('#contact')
        // this.$root.goto('Contact')
        // this.$router.push({ name: 'Contact' })
        // this.$router.push({ name: 'Home', params: { section: 'Contact' } })
        this.$router.replace({ name: 'Contact' })
      }
    }
  }
</script>
<style>
  .navbar-default {
    background-color: #367fa9;
  }
  .navbar-brand > img {
    height: 50px !important;
  }
  .navbar-nav > li > a {
    color: #fff !important;
    height: 50px;
    cursor: pointer;
  }

    .navbar-nav > li > a:hover {
      color: #000 !important;
    }

    .navbar-nav > li > a.active {
      color: #000 !important;
      border-bottom: 2px solid #000;
    }

  .navbar-default .navbar-toggle .icon-bar{
    background-color: #fff;
  }
  .navbar-default .navbar-toggle:focus, .navbar-default .navbar-toggle:hover {
    background-color: transparent;
  }
</style>



// WEBPACK FOOTER //
// navbar.vue?e69f3180